import { Link } from "react-router-dom";

export default function MobileHorizontalSection({ title, viewAll = "/stays", banner = null, children }) {
  return (
    <section className="hv-section">
      <div className="hv-section-head">
        <h2 className="hv-section-title">{title}</h2>
        {viewAll ? <Link className="hv-view-all" to={viewAll}>View All</Link> : null}
      </div>
      {banner}
      <div className="hv-scroll-row">{children}</div>
    </section>
  );
}
